// extracted by mini-css-extract-plugin
export default {"container":"index_container__xbz2Y","IconWrap":"index_IconWrap__OJwny","Icon":"index_Icon__2xBx1","flexCenter":"index_flexCenter__otfPN","accept":"index_accept__yY+os"};